<script setup lang="ts">
import type { Segment } from '@/types/types'

interface Props {
  excludedAudiences?: Segment[]
  includedAudiences?: Segment[]
}

withDefaults(defineProps<Props>(), {
  excludedAudiences: () => [] as Segment[],
  includedAudiences: () => [] as Segment[]
})

const { t } = useI18n()
</script>

<template>
  <div class="flex items-center">
    <AppTooltip
      v-if="excludedAudiences.length > 0 || includedAudiences.length > 0"
      tooltip-position="bottom"
      fit-content
      :escape="false"
    >
      <template #tooltip-content>
        <div class="flex flex-col gap-2">
          <div v-if="includedAudiences.length > 0" class="flex flex-col gap-2 px-1 text-left">
            <span class="text-sm text-primary-foreground">
              {{ t('pages.loyaltyPage.edit.fields.audienceIncluded') }}
            </span>
            <div class="flex flex-wrap gap-2">
              <BaseChip v-for="audience in includedAudiences" :key="audience.id" :text="audience.name" />
            </div>
          </div>

          <div v-if="excludedAudiences.length > 0" class="flex flex-col gap-2 px-1 text-left">
            <span class="text-sm text-primary-foreground">
              {{ t('pages.loyaltyPage.edit.fields.audienceExcluded') }}
            </span>
            <div class="flex flex-row flex-wrap gap-2">
              <BaseChip v-for="audience in excludedAudiences" :key="audience.id" :text="audience.name" />
            </div>
          </div>
        </div>
      </template>
      <BaseChip
        :text="t('pages.reward.table.audiencesTag', { count: includedAudiences.length + excludedAudiences.length })"
        icon="IconoirInfoCircle"
      />
    </AppTooltip>

    <div v-else>
      <BaseChip :text="t('pages.reward.table.allCustomers')" />
    </div>
  </div>
</template>
